import BaseClient from '@/app/model/api/response/baseApiClient'

class RecordCreateApi extends BaseClient {
  public doRecordCreate (bodyData: {[key:string]: string|number|number[]}, id: string) {
    const path:string = '/v1/planting-records/' + id

    /* 共通処理 */
    return super.setBody(JSON.stringify(bodyData)).doFetch(process.env.VUE_APP_API_URL + path, 'POST')
  }
}

export default new RecordCreateApi()
